<template>
  <div class="notfound-page">
    <header class="notfound-header">
      <router-link class="notfound-brand" :to="homePath">
        <img src="/brain-icon-96.jpg" alt="" width="28" height="28" />
        <span>Remote EMDR</span>
      </router-link>
    </header>

    <main class="notfound-inner">
      <h1>{{ $t('notFound.title') }}</h1>
      <p>{{ $t('notFound.text') }}</p>
      <router-link class="notfound-home" :to="homePath">{{ $t('notFound.home') }}</router-link>
    </main>
  </div>
</template>

<script>
import { applySeo } from './i18n/head';

// Catch-all route. The backend already answers these URLs with a 404 status,
// so this only has to give visitors a way back.
export default {
  computed: {
    homePath() {
      return this.$localePath('/');
    }
  },
  created() {
    applySeo({
      locale: this.$locale,
      routeBase: '',
      title: this.$t('notFound.metaTitle'),
      description: this.$t('notFound.metaDescription'),
      noindex: true
    });
  }
};
</script>

<style scoped>
.notfound-page {
  min-height: 100vh;
  background: var(--c-bg);
}
.notfound-header {
  padding: 1.1rem clamp(1.5rem, 5vw, 4rem);
  background: #16302c;
}
.notfound-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  color: white;
  font-family: var(--ff-heading);
  font-weight: 600;
  text-decoration: none;
}
.notfound-brand img {
  border-radius: 8px;
  object-fit: cover;
}
.notfound-inner {
  max-width: 760px;
  margin: 0 auto;
  padding: clamp(2.5rem, 7vh, 4rem) 16px 4rem;
}
.notfound-inner h1 {
  font-family: var(--ff-heading);
  font-size: clamp(1.9rem, 4vw, 2.5rem);
  font-weight: 700;
  color: var(--c-text);
  margin-bottom: 0.6rem;
}
.notfound-inner p {
  color: var(--c-text-light);
  font-size: 0.96rem;
  margin-bottom: 1.5rem;
}
.notfound-home {
  display: inline-block;
  padding: 0.7rem 1.4rem;
  border-radius: 10px;
  background: var(--c-primary);
  color: white;
  font-weight: 600;
}
.notfound-home:hover {
  background: var(--c-primary-light);
  color: white;
}
</style>
